import React from "react";
import { SimWagon } from "./SimWagon";
import { computeGeometry } from "../sim/geometry";
import { cargoLabel, trackLabel } from "../i18n";

// Renders the fan-out / parallel-track / fan-in rails and path-following wagons.
export const YardSchematic = ({ station, mode, selectedWagonId, onWagonClick, onDone, t, wagonSelectable }) => {
  const n = station.tracks.length;
  const large = station.type === "sorting";
  const g = computeGeometry(n, large);
  const { W, H, centerY, entryX, exitX, leftHubX, rightHubX, trackStartX, trackEndX } = g;

  const rail = "#3f3f46";
  const railHi = "#52525b";
  const wagons = station.tracks.flatMap((t) => t.wagons);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: "block", height: "auto" }} data-testid={`yard-svg-${station.code}`}>
      <defs>
        <marker id={`ar-${station.code}`} markerWidth="7" markerHeight="7" refX="5" refY="3" orient="auto">
          <path d="M0,0 L6,3 L0,6 Z" fill="#52525b" />
        </marker>
      </defs>

      {/* entry & exit single lines */}
      <line x1={entryX} y1={centerY} x2={leftHubX} y2={centerY} stroke={railHi} strokeWidth="2.5" markerEnd={`url(#ar-${station.code})`} />
      <line x1={rightHubX} y1={centerY} x2={exitX} y2={centerY} stroke={railHi} strokeWidth="2.5" markerEnd={`url(#ar-${station.code})`} />

      {/* throats + parallel tracks */}
      {station.tracks.map((track, i) => {
        const y = g.y(i);
        return (
          <g key={track.id} data-testid={`track-${track.id}`}>
            <path d={g.leftThroatD(i)} fill="none" stroke={rail} strokeWidth="2" />
            <path d={g.rightThroatD(i)} fill="none" stroke={rail} strokeWidth="2" />
            <line x1={trackStartX} y1={y - 2.5} x2={trackEndX} y2={y - 2.5} stroke={rail} strokeWidth="1.4" />
            <line x1={trackStartX} y1={y + 2.5} x2={trackEndX} y2={y + 2.5} stroke={rail} strokeWidth="1.4" />
            <circle cx={trackStartX} cy={y} r="2.6" fill="#71717a" />
            <circle cx={trackEndX} cy={y} r="2.6" fill="#71717a" />
            <text x={trackStartX + 6} y={y - 8} fontSize={large ? 9 : 8.5} fill="#a1a1aa" fontFamily="IBM Plex Mono" letterSpacing="0.5">
              {trackLabel(track.idx, t).toUpperCase()}
            </text>
            <text x={trackEndX} y={y - 8} fontSize={large ? 9 : 8.5} textAnchor="end" fill="#71717a" fontFamily="IBM Plex Mono">
              {track.count}/{track.capacity}
            </text>
          </g>
        );
      })}

      <circle cx={leftHubX} cy={centerY} r="4" fill="#38bdf8" />
      <circle cx={rightHubX} cy={centerY} r="4" fill="#38bdf8" />

      {wagons.map((w) => {
        const trackNum = w.tk + 1;
        const aria = typeof t("wagonAria") === "function"
          ? t("wagonAria")(w.number, cargoLabel(w.cargo, t), trackNum)
          : `${t("wagon")} ${w.number}`;
        return (
          <SimWagon
            key={w.id}
            w={w}
            geo={g}
            mode={mode}
            selected={selectedWagonId === w.id}
            onClick={onWagonClick}
            onDone={onDone}
            ariaLabel={aria}
            selectable={wagonSelectable}
          />
        );
      })}
    </svg>
  );
};
